<template>
<div class="col-md-3">
    <div class="sidebar" style="top:15px;">
        <button class="item-btn menu-margin micha-sidenav-font" :class="{ active: activeBtn == 'mi-cha/inicio' }" @click="cambiarActive('inicio')">
            <i class="fas fa-home"></i>Inicio
        </button>
        <button v-if="this.mostrar_beneficios" class="item-btn menu-margin micha-sidenav-font" :class="{ active: activeBtn == 'mi-cha/mis-beneficios' }" @click="cambiarActive('mis-beneficios')">
            <i class="fas fa-align-right"></i>Mis beneficios
        </button>
 
        <button class="item-btn menu-margin micha-sidenav-font" :class="{ active: activeBtn == 'mi-cha/certificados' }" @click="cambiarActive('certificados')">
            <i class="fas fa-file-alt"></i>Certificados
        </button>
        <button class="item-btn menu-margin micha-sidenav-font" :class="{ active: activeBtn == 'mi-cha/historial' }" @click="cambiarActive('historial')">
            <i class="fas fa-clock"></i>Mi historial en chileatiende
        </button>  
        <button class="item-btn menu-margin micha-sidenav-font" :class="{ active: activeBtn == 'mi-cha/mis-recordatorios' }" @click="cambiarActive('mis-recordatorios')">
            <i class="fas fa-envelope"></i>Mis recordatorios
        </button>  

        <button class="item-btn menu-margin micha-sidenav-font" :class="{ active: activeBtn == 'mi-cha/perfil' }" @click="cambiarActive('perfil')">
            <i class="fas fa-user-cog"></i>Mis datos
        </button>
        <button class="item-btn menu-margin micha-sidenav-font" :class="{ active: activeBtn == 'mi-cha/casos' }" @click="cambiarActive('casos')">
            <i class="fas fa-clock"></i>Mi historial de casos
        </button>      
    </div>
</div>
</template>
<style lang="scss" scoped>
    .menu-margin{
        margin-bottom:7px;
    }
    .micha-sidenav-font{
        font-weight: 400 !important;
        text-decoration: underline !important;
    }
</style>
<script>
    import Percentage from './Percentage.vue';
    export default {
        name: "HomeSidebar",
        components: {Percentage},
        data: function(){
            return{
                activeBtn: '',
                displayNotificaciones: 'none',
                noLeidasCount: null
            }
        },
        mounted(){
            if (this.boton!=null) {
                this.displayNotificaciones = this.boton['display'];
                this.activeBtn = _.cloneDeep(this.boton['boton']);
                this.noLeidasCount = this.boton['notificationCount'];
            }
        },
        props: ['boton','user','percentage','mostrar_beneficios'],
        methods:{
            cambiarActive: function(button)
            {
                this.activeBtn = button;
                if (button == 'openNotificaciones') {
                    if (this.displayNotificaciones == 'none'){
                        this.displayNotificaciones = 'block';
                    } else{
                        this.displayNotificaciones = 'none';
                    }
                }else{
                    this.cambiarPagina(button);
                }
            },
            cambiarPagina: function (pagina)
            {
                window.location = '/mi-cha/' + pagina;
            },
        }
    }
</script>